/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { HTMLAttributes } from 'preact/compat';
import { classes, VComponent } from '@adobe-commerce/elsie/lib';
import { FunctionComponent, VNode } from 'preact';
import '@/cart/components/OrderSummaryLine/OrderSummaryLine.css';
export interface OrderSummaryLineComponentProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'label'> {
  label: VNode | string;
  price: VNode<HTMLAttributes<HTMLSpanElement>>;
  classSuffixes?: Array<string>;
  labelClassSuffix?: string;
  testId?: string;
  children?: any;
}

export const OrderSummaryLine: FunctionComponent<
  OrderSummaryLineComponentProps
> = ({
  label,
  price,
  classSuffixes = [],
  labelClassSuffix,
  testId,
  children,
  ...props
}) => {
  const labelClass = 'cart-order-summary__label';
  const priceClass = 'cart-order-summary__price';
  return (
    <div
      {...props}
      {...(testId ? { 'data-testid': testId } : {})}
      className={classes([
        'cart-order-summary__entry',
        ...classSuffixes.map(
          (classSuffix) => `cart-order-summary__${classSuffix}`
        ),
      ])}
    >
      <span
        className={classes([
          labelClass,
          ...(labelClassSuffix ? [`${labelClass}--${labelClassSuffix}`] : []),
        ])}
      >
        {label}
      </span>

      <VComponent
        node={price}
        className={classes([
          priceClass,
          ...(labelClassSuffix ? [`${priceClass}--${labelClassSuffix}`] : []),
        ])}
      />

      {children}
    </div>
  );
};
